<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/spmgr/select"
      :model="formModel"
      @openAddDialog="addInfo"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      addShowPower="/spmgr/add"
    >
      <el-form-item label="类型名称" prop="typeName">
        <el-input
          type="text"
          maxlength="20"
          v-model="formModel.typeName"
          placeholder="请输入类型名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="键" prop="key">
        <el-input
          type="text"
          maxlength="20"
          v-model="formModel.key"
          placeholder="请输入键"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="desc">
        <el-input
          type="text"
          maxlength="20"
          v-model="formModel.desc"
          placeholder="请输入描述"
        ></el-input>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="typeName"
        label="类型名称"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="paramKey"
        label="键"
        min-width="100"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="paramValue"
        label="值"
        min-width="100"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="paramDesc"
        label="备注"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="操作"
        min-width="120"
        v-if="hasPerm('/spmgr/edit')"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="addInfo(scope.row.id)">修改</el-button>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="formDialogTitle"
      :model="dialogModel"
      :dialogService="dialogService"
      :submitData="dialogData"
      :rules="dialogRules"
      class="over"
      @success="dialogSuccess"
      @close="dialogClose"
      @opend="dialogOpen"
      labelWidth="140px"
    >
      <el-form-item label="类型名称" prop="typeName">
        <el-input
          type="text"
          maxlength="100"
          show-word-limit
          v-model="dialogModel.typeName"
          placeholder="请输入类型名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="键" prop="paramKey">
        <el-input
          type="text"
          maxlength="50"
          show-word-limit
          v-model="dialogModel.paramKey"
          v-bind:readonly="readOnly"
          placeholder="请输入键"
        ></el-input>
      </el-form-item>
      <el-form-item label="值" prop="paramValue">
        <el-input
          type="text"
          maxlength="1000"
          show-word-limit
          v-model="dialogModel.paramValue"
          placeholder="请输入值"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="desc">
        <el-input
          type="textarea"
          resize="none"
          rows="5"
          maxlength="50"
          show-word-limit
          v-model="dialogModel.paramDesc"
          placeholder="请输入备注"
        ></el-input>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import SystemPropertiesService from "service/SystemPropertiesService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "systempropertiesmanage",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  data() {
    return {
      formModel: {
        typeName: "",
        key: "",
        desc: "",
      },
      params: {},
      page: {},
      tableData: [],
      submitService: SystemPropertiesService.list,
      formDialogTitle: "",
      dialogModel: {},
      dialogRules: {
        typeName: [
          {
            required: true,
            message: "请输入字典类型名称",
          },
        ],
        paramKey: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入键"));
              }
              this.checkKey(value, (res) => {
                res.contents.checkFlag
                  ? callback(new Error("通道真实名称已存在"))
                  : callback();
              });
            },
          },
        ],
        paramValue: [
          {
            required: true,
            message: "请输入值",
          },
        ],
        paramDesc: [
          {
            required: true,
            message: "请输入备注",
          },
        ],
      },
      dictId: "",
      getTypeName: "",
      getDictKey: "",
      isPage: false,
      readOnly: false,
    };
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.page = this.$refs.commonTable.page;
    this.getList();
  },
  computed: {
    dialogService() {
      if (this.dictId) {
        return SystemPropertiesService.update;
      } else {
        return SystemPropertiesService.add;
      }
    },
    dialogData() {
      const params = {
        typeName: this.dialogModel.typeName,
        paramKey: this.dialogModel.paramKey,
        paramValue: this.dialogModel.paramValue,
        paramDesc: this.dialogModel.paramDesc,
      };
      if (this.dictId) {
        params.id = this.dictId;
      }
      return params;
    },
    submitData() {
      this.params = {
        typeName: this.formModel.typeName.trim(),
        key: this.formModel.key.trim(),
        desc: this.formModel.desc.trim(),
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return this.params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  methods: {
    checkKey(key, onSuccess) {
      const param = {
        id: this.dictId,
        key: key,
      };
      this.doLoad(
        SystemPropertiesService.exist,
        param,
        (res) => {
          this.doCheck(res, (res) => {
            onSuccess && onSuccess(res);
          });
        },
        "信息获取失败"
      );
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        SystemPropertiesService.list,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.tableData = result.rows;
            // console.log(result.rows)
            this.page.currentPage = result.current;
            this.page.total = result.total;
            this.page.pageSize = result.size;
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    getDetail() {
      const detailParams = {
        id: this.dictId,
      };
      this.doLoad(
        SystemPropertiesService.detail,
        detailParams,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.dialogModel = result;
            this.getTypeName = this.dialogModel.typeName;
            this.getDictKey = this.dialogModel.dictKey;
          });
        },
        "信息获取失败"
      );
    },
    addInfo(id) {
      this.dictId = id;
      if (this.dictId) {
        this.readOnly = true;
        this.formDialogTitle = "修改配置";
        this.getDetail();
      } else {
        this.formDialogTitle = "添加配置";
        this.readOnly = false;
      }
      this.$refs.formDialog.open();
    },
    onSuccess(data) {
      this.doCheck(data, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    dialogSuccess() {
      this.$refs.formDialog.closeDialog();
      this.dictId = "";
      this.getList();
    },
    dialogOpen() {},
    dialogClose() {
      this.dialogModel = {};
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/SystemManage/SystemPropertiesManage.vue